import React from 'react'
import styled from 'styled-components'

const ChevronBox = styled.svg`
  transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`

export const ChevronSvg = ({ $expanded }) => (
  <ChevronBox
    $expanded={$expanded}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
  </ChevronBox>
)
